import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";
import closeImg from "../images/close.png";
import Select from "react-select";
import { GETREQUEST, POSTREQUEST } from "../component/helpers/ServiceRequest";
import Toastify from "../component/common/Toastify";
import { addTrailingZeros, formatPrice } from "../component/helpers/common";

function AddOrderModal(props) {
  const { user, customerId, OrderID, setModal, updateOrderDetails, modal, crates, units, customerCategory } = props
  const [agents, setAgents] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState('');
  const [products, setProducts] = useState(null);
  const [classNames, setClassNames] = useState(null);
  const [sizeNames, setSizeNames] = useState(null);
  const [unitNames, setUnitNames] = useState(null);
  const [formDataArray, setFormDataArray] = useState([]);
  const formDefaultValues = {
    OrderID: '',
    AgentID: '',
    Qty: '',
    UnitID: '',
    ProductID: '',
    ProductName: '',
    ProductCode: '',
    Comment: '',
    ClassName: '',
    SizeName: '',
    ContainerID: '',
    Count: '',
    IgnoreCrate: 0,
    LastSellPU: '',
    SellPrice: '',
    BuyPrice: '',
    Profit: '',
    RRP: '',
    ExtBuy: '',
    ExtSell: '',
    ExtRRP: '',
    RetailPC: ''
  }
  const [formData, setFormData] = useState(formDefaultValues);
  const [errorFormFields, setErrorFormFields] = useState({});
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  useEffect(() => {

    const fetchData = async () => {
      let fetchAllAgentsURL = process.env.REACT_APP_API_URL + `/fetch-all-agents`;
      let PURL = process.env.REACT_APP_API_URL + `/search-order-product/${customerId}`;

      let fetchAgentResponse = await GETREQUEST(fetchAllAgentsURL, user.jwtToken);
      let productResponse = await GETREQUEST(PURL, user.jwtToken);

      if (fetchAgentResponse?.data) {
        let newArrayAgents = [];
        fetchAgentResponse.data.forEach((data) => {
          let newObj = { label: data.AgentCode, value: data.AgentID, ...data };
          newArrayAgents.push(newObj);
        });
        setAgents(newArrayAgents);
      }

      if (productResponse?.data) {
        const sortedOptions = [...productResponse.data].sort((a, b) => Number(a.label) - Number(b.label));
        setProducts(sortedOptions)
      }
    }

    fetchData();
  }, []);

  const CustomOptionAgent = (props) => {
    return (
      <div>
        <div
          className=""
          style={{
            background: props.isFocused
              ? '#01B1E3'
              : props.isSelected
                ? 'rgb(54, 179, 126)'
                : "#fff", color: "gray", zIndex: 1, padding: " 8px 12px", cursor: "default", display: "block", fontSize: "inherit", width: "100%"
          }}
          {...props.innerProps}
          ref={props.innerRef}
        >
          {props.label}
        </div>
      </div>
    )
  }

  const calculateProfit = (buyPrice, sellPrice) => {
    if (buyPrice > 0 && sellPrice > 0) {
      let profit = 100 - (buyPrice / sellPrice * 100)
      profit = isNaN(profit) ? 0 : parseFloat(profit).toFixed(2);
      setFormData(prevData => ({
        ...prevData,
        ['Profit']: profit
      }));
    }
  }

  const calculateTtlProd = (qty, count, sellPrice, buyPrice, RRP, isIgnoreCrate = false) => {
    count = count ? count : 1;
    let value = isIgnoreCrate ? count : qty * count;
    let extSell = value * sellPrice;
    let extBuy = value * buyPrice;
    let extRRP = value * RRP;

    extSell = extSell ? parseFloat(extSell).toFixed(2) : extSell;
    extBuy = extBuy ? parseFloat(extBuy).toFixed(2) : extBuy;
    extRRP = extRRP ? parseFloat(extRRP).toFixed(2) : extRRP;
    setFormData(prevData => ({
      ...prevData,
      ['ExtBuy']: extBuy,
      ['ExtSell']: extSell,
      ['ExtRRP']: extRRP
    }));

    if (sellPrice > 0 && RRP > 0) {
      let RetailPC = 100 - (sellPrice / RRP * 100)
      RetailPC = RetailPC ? parseFloat(RetailPC).toFixed(2) : RetailPC;
      setFormData(prevData => ({
        ...prevData,
        ['RetailPC']: RetailPC
      }));
    }
  }

  const checkErrorFields = async () => {
    const fields = ['AgentID', 'Qty', 'UnitID', 'ProductID', 'ContainerID'];
    let updatedErrorFields = { ...errorFormFields };

    await Promise.all(fields.map(async field => {
      if (!formData[field]) {
        updatedErrorFields[field] = true;
      } else {
        delete updatedErrorFields[field];
      }
    }));

    setErrorFormFields(updatedErrorFields);
    return Object.keys(updatedErrorFields).length > 0;
  };

  const checkError = (field) => {
    let updatedErrorFields = { ...errorFormFields };

    if (!formData[field]) {
      updatedErrorFields[field] = true;
    } else {
      delete updatedErrorFields[field];
    }

    if (field == "ContainerID") {
      delete updatedErrorFields[field];
    }
    setErrorFormFields(updatedErrorFields);
  };

  const handleProductChange = (e) => {
    if (!e) return;

    const selectedProduct = e.product;
    const productDetails = selectedProduct?.tblProductDetails || [];

    let unitL = new Set();
    let classL = new Set();
    let sizeL = new Set();

    productDetails.forEach((item) => {
      const commonObj = {
        DefAgentID: item.DefAgentID,
        RRP: parseFloat(item.RRP || 0),
        SellPrice: parseFloat(item[`Sell${customerCategory}`] || 0),
        BuyPrice: parseFloat(item.Cost || 0),
        Count: parseInt(item.Wgt || 0),
      };

      if (item.DefUnitID != null) {
        const unit = units.find(unit => unit.value === item.DefUnitID);
        if (unit) unitL.add({ label: unit.label, value: unit.value, ...commonObj });
      }

      if (item.DefClass != null) {
        classL.add({ label: item.DefClass, value: item.DefClass, ...commonObj });
      }

      if (item.DefSize != null) {
        sizeL.add({ label: item.DefSize, value: item.DefSize, ...commonObj });
      }
    });

    // Convert Set to Array
    unitL = Array.from(unitL);
    classL = Array.from(classL);
    sizeL = Array.from(sizeL);

    const UnitObj = unitL?.length > 0 ? unitL[0] : {};
    // Prefill previous finalized order details
    const prevOrder = selectedProduct.tblOrderDetails;
    const updatedForm = {
      ProductID: e?.value || '',
      ProductName: selectedProduct?.ProductName || '',
      ProductCode: selectedProduct?.ProductCode || '',
      UnitID: prevOrder ? prevOrder?.UnitID : (UnitObj?.value || ''),
      ClassName: prevOrder ? prevOrder?.ClassName : (classL[0]?.value || ''),
      SizeName: prevOrder ? prevOrder?.SizeName : (sizeL[0]?.value || ''),
      Count: prevOrder ? prevOrder?.Count : (UnitObj?.Count || ''),
      BuyPrice: prevOrder ? addTrailingZeros(prevOrder?.BuyPrice) : (addTrailingZeros(UnitObj?.BuyPrice) || ''),
      SellPrice: prevOrder ? addTrailingZeros(prevOrder?.SellPrice) : (addTrailingZeros(UnitObj?.SellPrice) || ''),
      RRP: prevOrder ? addTrailingZeros(prevOrder?.RRP) : (addTrailingZeros(UnitObj?.RRP) || ''),
      LastSellPU: prevOrder ? prevOrder?.SellPrice : 0,
    };

    setFormData(prev => ({ ...prev, ...updatedForm }));

    setClassNames(classL);
    setSizeNames(sizeL);
    setUnitNames(unitL);
    setSelectedProduct(e);
    setFormData(prev => ({ ...prev, ...updatedForm }));

    calculateProfit(updatedForm.BuyPrice, updatedForm.SellPrice);
    calculateTtlProd(
      formData['Qty'],
      updatedForm.Count,
      updatedForm.SellPrice,
      updatedForm.BuyPrice,
      formData['RRP'],
      formData['IgnoreCrate']
    );
  };


  const handleAddOrder = async () => {
    let isError = await checkErrorFields();
    if (!isError) {
      let updatedFormData = {
        ...formData,
        Count: formData.Count || 0,
        ClassName: formData.ClassName || '',
        SizeName: formData.SizeName || '',
        SellPrice: formData.SellPrice || 0,
        BuyPrice: formData.BuyPrice || 0,
        Profit: formData.Profit || 0,
        RRP: formData.RRP || 0,
        ExtBuy: formData.ExtBuy || 0,
        ExtSell: formData.ExtSell || 0,
        ExtRRP: formData.ExtRRP || 0,
        RetailPC: formData.RetailPC || 0
      }
      let tempFormDataArray = [...formDataArray, updatedFormData];
      setFormDataArray(tempFormDataArray)
      setFormData(formDefaultValues);
      setSelectedProduct('');
      setClassNames(null);
      setSizeNames(null);
      setUnitNames(null);
      return tempFormDataArray;
    }
  }

  const handleOrderSave = async () => {
    let addNewOrder = formDataArray;
    if (formData.AgentID && formData.ProductID) {
      addNewOrder = await handleAddOrder();
    }
    if (addNewOrder?.length > 0) {
      setMessage('');
      setMessageType('');
      if (OrderID) {
        let URL = process.env.REACT_APP_API_URL + "/add-order-details";
        setFormData(formDefaultValues);
        setClassNames(null);
        setSizeNames(null);
        setUnitNames(null);
        let payload = {
          OrderDetails: addNewOrder,
        }

        let response = await POSTREQUEST(URL, payload, user.jwtToken);
        if (response.data.success) {
          updateOrderDetails(response.data.orderDetails);
          setMessage(response.data.message)
          setMessageType('success')
          setTimeout(() => {
            setModal(false);
          }, 2000);

        } else {
          setMessage(response.data.message)
          setMessageType("error")
        }
      }
    } else {
      return;
    }

  }

  const customFilter = (option, inputValue) => {
    if (!inputValue) return true;
    return option.label.startsWith(inputValue);
  };

  const handleUnitChange = (unitObj) => {
    let selectedProductDetails = products.find(item => item.product.ProductCode == formData['ProductCode'])?.product?.tblProductDetails
    let selectedUnitObj = selectedProductDetails?.find(item => item.DefUnitID === unitObj.value);
    let selectedClass = classNames?.find(classN => classN.value == selectedUnitObj?.DefClass);
    let selectedSize = sizeNames?.find(sizeN => sizeN.value == selectedUnitObj?.DefSize);
    setFormData((prevData) => ({
      ...prevData,
      ['UnitID']: unitObj?.value || '',
      ['ClassName']: selectedClass?.value || '',
      ['SizeName']: selectedSize?.value || '',
      ['BuyPrice']: addTrailingZeros(unitObj?.BuyPrice || 0),
      ['Count']: unitObj?.Count || 0,
      ['SellPrice']: addTrailingZeros(unitObj?.SellPrice || 0),
      ['RRP']: addTrailingZeros(unitObj?.RRP || 0),
    }));
    calculateProfit(unitObj?.BuyPrice, unitObj?.SellPrice);
    calculateTtlProd(
      formData['Qty'],
      unitObj?.Count,
      unitObj?.SellPrice,
      unitObj?.BuyPrice,
      unitObj?.RRP,
      formData['IgnoreCrate']
    );
  }

  return ReactDOM.createPortal(
    <React.Fragment>
      {message && <Toastify message={message} type={messageType} />}
      <div
        className={"modal fade " + (modal ? "show " : "")}
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        style={modal ? { display: "block" } : { display: "none" }}
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-darkgrey p-2 px-3">
              <h1
                className="modal-title fs-16 text-white"
                id="exampleModalLabel"
              >
                Add to Order
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  backgroundImage: `url(${closeImg})`,
                  opacity: 1,
                  padding: "16px",
                }}
                onClick={() => setModal(false)}
              ></button>
            </div>
            <div className="modal-body py-4 px-4">
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Agent:
                </label>
                <div className="col">
                  <Select
                    className={`input-sm  input-width-160 ${errorFormFields['AgentID'] ? "is-invalid-custom" : ''}`}
                    defaultValue={"Select Agent"}
                    value={agents.find(agent => agent.value == formData['AgentID']) || ''}
                    options={agents}
                    placeholder="Select Agent"
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        ['AgentID']: e.value,
                        ['OrderID']: OrderID
                      }))
                    }}
                    components={{ Option: CustomOptionAgent }}
                  />
                </div>
              </div>

              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Product:
                </label>
                <div className="col-sm-2">
                  <Select
                    className={`input-sm  input-width-160 ${errorFormFields['ProductID'] ? "is-invalid-custom" : ''} `}
                    filterOption={customFilter}
                    isSearchable
                    defaultValue={"Select Product"}
                    value={selectedProduct}
                    options={products}
                    placeholder="Select Product"
                    onChange={(e) => handleProductChange(e)}
                    components={{ Option: CustomOptionAgent }}
                  />
                </div>
                <div className="row mt-2">
                  <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                    ProductName:
                  </label>
                  <div className="col">
                    <input type="text" className="form-control input-sm" placeholder="Product Name" value={formData['ProductName']} disabled />
                  </div>
                </div>
              </div>

              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Qty:
                </label>
                <div className="col">
                  <input
                    type="text"
                    className={`form-control input-sm text-end ${errorFormFields['Qty'] ? "is-invalid-custom" : ''}`}
                    placeholder="0"
                    value={formData['Qty']}
                    onChange={(e) => setFormData((prevData) => ({
                      ...prevData,
                      ['Qty']: formatPrice(e.target.value)
                    }))}
                    onBlur={(e) => {
                      checkError('Qty')
                      setFormData((prevData) => ({
                        ...prevData,
                        ['Qty']: addTrailingZeros(e.target.value)
                      }))
                      calculateTtlProd(e.target.value, formData['Count'], formData['SellPrice'], formData['BuyPrice'], formData['RRP'], formData['IgnoreCrate'])
                    }}
                  />
                </div>
              </div>

              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Unit:
                </label>
                <div className="col">
                  <Select
                    className={`input-sm  input-width-160 ${errorFormFields['UnitID'] ? "is-invalid-custom" : ''} `}
                    defaultValue={"Select Unit"}
                    value={units.find(unit => unit.value == formData['UnitID']) || ''}
                    options={unitNames}
                    placeholder="Select Unit"
                    onChange={handleUnitChange}
                    components={{ Option: CustomOptionAgent }}
                  />
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Class:
                </label>
                <div className="col">
                  <Select
                    className={`input-sm  input-width-160`}
                    filterOption={customFilter}
                    isSearchable
                    defaultValue={"Select Class"}
                    value={classNames?.find(classN => classN.value == formData['ClassName']) || ''}
                    options={classNames}
                    placeholder="Select Class"
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        ['ClassName']: e.value
                      }))
                    }}
                    components={{ Option: CustomOptionAgent }}
                  />
                </div>
              </div>

              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Size:
                </label>
                <div className="col">
                  <Select
                    className={`input-sm  input-width-160`}
                    filterOption={customFilter}
                    isSearchable
                    defaultValue={"Select Size"}
                    value={sizeNames?.find(sizeN => sizeN.value == formData['SizeName']) || ''}
                    options={sizeNames}
                    placeholder="Select Size"
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        ['SizeName']: e.value
                      }))
                    }}
                    components={{ Option: CustomOptionAgent }}
                  />
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Crate:
                </label>
                <div className="col">
                  <Select
                    className={`input-sm  input-width-160 ${errorFormFields['ContainerID'] ? "is-invalid-custom" : ''}`}
                    defaultValue={"Select Crate"}
                    value={crates.find(crate => crate.ContainerID == formData['ContainerID']) || ''}
                    options={crates}
                    placeholder="Select Crate"
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        ['ContainerID']: e.value
                      }))
                      checkError('ContainerID')
                    }}
                    components={{ Option: CustomOptionAgent }}
                  />
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-start justify-content-end fs-14 text-lite text-nowrap">
                  Count:
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-sm text-end"
                    placeholder="0"
                    value={formData['Count']}
                    onChange={(e) => setFormData((prevData) => ({
                      ...prevData,
                      ['Count']: e.target.value
                    }))}
                  />

                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  t:
                </label>
                <div className="col">
                  <input
                    type="checkbox"
                    className="form-check-input pe-0"
                    value={formData['IgnoreCrate']}
                    onChange={(e) => {
                      setFormData((prevData) => ({
                        ...prevData,
                        ['IgnoreCrate']: e.target.checked ? 1 : 0
                      }))
                      calculateTtlProd(formData['Qty'], formData['Count'], formData['SellPrice'], formData['SellPrice'], formData['RRP'], e.target.checked)
                    }}
                  />
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Sell Price:
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4"
                      placeholder="0.00"
                      value={formData['SellPrice']}
                      onChange={(e) => setFormData((prevData) => ({
                        ...prevData,
                        ['SellPrice']: formatPrice(e.target.value)
                      }))}
                      onBlur={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          ['SellPrice']: addTrailingZeros(e.target.value)
                        }))
                        calculateProfit(formData['BuyPrice'], e.target.value);
                        calculateTtlProd(formData['Qty'], formData['Count'], e.target.value, formData['BuyPrice'], formData['RRP'], formData['IgnoreCrate'])
                      }}
                    />
                    <span className="text-lite cps-10 fs-14">$</span>
                  </div>
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Buy Price:
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4"
                      placeholder="0.00"
                      value={formData['BuyPrice']}
                      onChange={(e) => setFormData((prevData) => ({
                        ...prevData,
                        ['BuyPrice']: formatPrice(e.target.value)
                      }))}
                      onBlur={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          ['BuyPrice']: addTrailingZeros(e.target.value)
                        }))
                        calculateProfit(e.target.value, formData['SellPrice'])
                        calculateTtlProd(formData['Qty'], formData['Count'], formData['SellPrice'], e.target.value, formData['RRP'], formData['IgnoreCrate'])
                      }}
                    />
                    <span className="text-lite cps-10 fs-14">$</span>
                  </div>
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  % Profit:
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-sm text-end"
                    placeholder="0"
                    value={formData['Profit']}
                    // onChange={(e) => setFormData((prevData) => ({
                    //   ...prevData,
                    //   ['Profit']: e.target.value
                    // }))}
                    readOnly
                  />
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Total Sell Price:
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4"
                      placeholder="0.00"
                      value={formData['ExtSell']}
                      onChange={(e) => setFormData((prevData) => ({
                        ...prevData,
                        ['ExtSell']: e.target.value
                      }))}
                    />
                    <span className="text-lite cps-10 fs-14">$</span>
                  </div>
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  RRP:
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className={`form-control input-sm text-end ps-4 ${errorFormFields['RRP'] ? "is-invalid-custom" : ''} `}
                      placeholder="0.00"
                      value={formData['RRP']}
                      onChange={(e) => setFormData((prevData) => ({
                        ...prevData,
                        ['RRP']: e.target.value
                      }))}
                      onBlur={(e) => {
                        setFormData((prevData) => ({
                          ...prevData,
                          ['RRP']: addTrailingZeros(e.target.value)
                        }))
                        calculateTtlProd(formData['Qty'], formData['Count'], formData['SellPrice'], formData['BuyPrice'], e.target.value, formData['IgnoreCrate'])
                      }}
                    />
                    <span className="text-lite cps-10 fs-14">$</span>
                  </div>
                </div>
              </div>
              <div className="cmb-12 row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Extended RRP:
                </label>
                <div className="col">
                  <div className="position-relative input-icon">
                    <input
                      type="text"
                      className="form-control input-sm text-end ps-4"
                      placeholder="0.00"
                      value={formData['ExtRRP']}
                      onChange={(e) => setFormData((prevData) => ({
                        ...prevData,
                        ['ExtRRP']: e.target.value
                      }))}
                    />
                    <span className="text-lite cps-10 fs-14">$</span>
                  </div>
                </div>
              </div>
              <div className="row g-3">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Gross Profit %:
                </label>
                <div className="col">
                  <input
                    type="text"
                    className="form-control input-sm text-end"
                    placeholder="0.00"
                    defaultValue={formData['RetailPC']}
                  />
                </div>
              </div>

            </div>
            <div className="modal-footer">
              <div className="col d-flex">
                <label className="width-sm-25 d-flex align-items-center justify-content-end fs-14 text-lite text-nowrap">
                  Items :
                </label>
                <input
                  type="text"
                  className="form-control input-sm text-end"
                  placeholder="0"
                  value={formDataArray.length}
                  disabled
                />
              </div>
              <div className="col d-flex justify-content-end align-items-end">
                <button
                  onClick={handleAddOrder}
                  className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                >
                  Add
                </button>
                <button
                  className="btn btn-md btn-outline-secondary d-flex align-items-center px-4 fw-medium rounded-3 mx-1"
                  onClick={handleOrderSave}
                >
                  Save
                </button>
                <button
                  onClick={() => setModal(false)}
                  className="btn btn-md btn-secondary d-flex align-items-center px-4 fw-medium text-white rounded-3 mx-1"
                >
                  Exit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {modal ? <div className="modal-backdrop fade show" /> : ""}
    </React.Fragment>,
    document.getElementById("modal-root")
  );
}
export default AddOrderModal;
